// Ls - localStorage

export const LOGIN_SYNC_LS_KEY = 'whop:starter:login:sync';
